import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { HiOutlineUserRemove } from 'react-icons/hi'; // or MdPersonOff
import { useUnsavedChanges } from "../../../context/UnsavedChangesContext";
import { Eye, EyeOff } from 'lucide-react';

const AccountSettingsPage = () => {
  const [userData, setUserData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [phoneError, setPhoneError] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);


  const [currentField, setCurrentField] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [newValue, setNewValue] = useState("");
  const [nameInputs, setNameInputs] = useState({ firstName: "", lastName: "" });

  const [showModal, setShowModal] = useState(false);

  const { setIsDirty } = useUnsavedChanges();

  const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

const [showCancelModal, setShowCancelModal] = useState(false); // State to control the cancel confirmation modal

const handleCancel = async () => {
  const email = localStorage.getItem("email"); // Retrieve the email from localStorage
  if (email) {
    await fetchUserDetails(email); // Fetch and reset the data to the original state
  }
  setNewValue(""); // Clear any new value
  setNameInputs({ firstName: "", lastName: "" }); // Reset name inputs
  setPasswordInputs({ newPassword: "", confirmPassword: "" }); // Reset password inputs
  setPhoneError(""); // Clear phone error
  setCurrentField(""); // Clear the current field
  setIsDirty(false); // Mark the form as not dirty
  setShowModal(false); // Close any open modal
  setShowCancelModal(false); // Close the cancel confirmation modal
};

  const [passwordInputs, setPasswordInputs] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase();
  };

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (email) {
      fetchUserDetails(email);
    }
  }, []);



  const fetchUserDetails = async (email) => {
    try {
      const response = await fetch("https://vendor-score.finkraftai.com/get-user-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      setUserData(data);
      setEditData(data);
      if (data.profileImage) {
        setProfileImage(data.profileImage);
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const handleEdit = (field) => {
    if (field === "password") {
        setIsDirty(false); // Set isDirty to false for password field
    } else {
        setIsDirty(true); // Set isDirty to true for other fields
    }
    setCurrentField(field);
    if (field === "name") {
        setNameInputs({ firstName: editData.firstName, lastName: editData.lastName });
    } else {
        setNewValue(editData[field]);
    }
    setShowModal(true);
};

  const isDataChanged = () => {
    return JSON.stringify(editData) !== JSON.stringify(userData);
  };

  const handleSubmit = () => {
    if (currentField === "phone") {
      // Validate phone number
      if (!/^\d{10}$/.test(newValue)) {
        setPhoneError("Phone number must be 10 digits and contain only numbers.");
        return;
      }
      setPhoneError(""); // Clear error if valid
    }
  
    if (currentField === "name") {
      setEditData((prev) => ({
        ...prev,
        firstName: nameInputs.firstName,
        lastName: nameInputs.lastName,
      }));
    } else {
      setEditData((prev) => ({ ...prev, [currentField]: newValue }));
    }
  
    setShowModal(false);
    setNewValue("");
    setNameInputs({ firstName: "", lastName: "" });
    setCurrentField("");
  };
  const handleSaveClick = async () => {
    setIsDirty(false);
    try {
      let base64Image = null;
  
      if (profileImage instanceof File) {
        base64Image = await toBase64(profileImage);
      } else {
        base64Image = profileImage; // already base64 or URL
      }
  
      const payload = {
        email: userData.email,
        firstName: editData.firstName,
        lastName: editData.lastName,
        phone: editData.phone,
        company: editData.company,
        department: editData.department,
        role: editData.role,
        profileImage: base64Image, // ✅ Include base64 image
      };
  
      const response = await fetch("https://vendor-score.finkraftai.com/update-user-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        setUserData(editData);
        setIsModalOpen(true);
      } else {
        console.error("Failed to update user data");
        alert("Update failed.");
      }
    } catch (error) {
      console.error("Error updating user data:", error);
      alert("Update failed.");
    }
  };

  // ✅ Utility function to convert image file to base64
  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


  const getFieldLabel = (field) => {
    switch (field) {
      case "email":
        return "Email Address";
      case "phone":
        return "Phone No.";
      case "company":
        return "Company";
      case "name":
        return "Name";
      case "password":
        return "Password";
      default:
        return "";
    }
  };

  const [emailStep, setEmailStep] = useState(1); // Step 1: enter email, Step 2: enter OTP
  const [newEmail, setNewEmail] = useState("");
  const [otpCode, setOtpCode] = useState("");


  if (!userData) {
    return <div></div>;
  }





  const handlepassSubmit = async () => {
    const { newPassword, confirmPassword } = passwordInputs;
    const email = localStorage.getItem("email");

    if (!newPassword || !confirmPassword) {
        toast.success("Both fields are required.");
        return;
    }

    const alphanumericRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;

    if (!alphanumericRegex.test(newPassword)) {
        toast.success("Password must be at least 6 characters and contain both letters and numbers.");
        return;
    }

    if (newPassword !== confirmPassword) {
        toast.success("Passwords do not match.");
        return;
    }

    try {
        const res = await axios.post("https://vendor-score.finkraftai.com/api/change-password", {
            email: email, // make sure user is defined
            newPassword,
        });

        if (res.status === 200) {
            toast.success("Password updated successfully!");
            setShowModal(false);
        } else {
            toast.success("Error updating password.");
        }
    } catch (error) {
        toast.success("Server error: " + error.message);
    }
};

  const handleSendOtp = async () => {
    try {
      const checkRes = await fetch("https://vendor-score.finkraftai.com/check-user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: newEmail }),
      });

      const checkData = await checkRes.json();

      if (checkData.exists) {
        toast.info("User already exists. Please login instead.");
        // setShowPopup(true);
        // setTimeout(() => setShowPopup(false), 8000);
        return;
      }

      const res = await fetch("https://vendor-score.finkraftai.com/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: newEmail }),
      });

      const data = await res.json();

      if (data.success) {
        toast.success("OTP sent successfully!");
        setEmailStep(2); // move to step 2
      } else {
        toast.error("Failed to send OTP");
      }
    } catch (err) {
      console.error("Error occurred:", err);
      toast.error("Something went wrong");
    }
  };

  const handleChangeEmail = async () => {
    try {
      // Get the current email from localStorage
      const currentEmail = localStorage.getItem("email");

      // Proceed with OTP verification
      const res = await fetch("https://vendor-score.finkraftai.com/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: newEmail, otp: otpCode }),
      });

      const data = await res.json();

      if (data.success) {
        // If OTP is valid, update email in the backend
        const updateRes = await fetch("https://vendor-score.finkraftai.com/update-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            oldEmail: currentEmail, // Current email from localStorage
            newEmail: newEmail,     // New email
          }),
        });

        const updateData = await updateRes.json();

        if (updateData.success) {
          toast.success("Email updated successfully!");

          // Optionally, update localStorage with the new email
          localStorage.setItem("email", newEmail);

          // Update state (if you're using React state for the email)
          setEditData((prev) => ({ ...prev, email: newEmail }));

          // Close the modal after success
          setShowModal(false);
        } else {
          toast.error("Error updating email. Please try again.");
        }
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.error("Verification failed:", err);
      toast.error("Something went wrong.");
    }
  };



  const styles = {
    overlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      background: '#ffffff',
      padding: '30px',
      borderRadius: '16px',
      textAlign: 'center',
      width: '340px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      animation: 'fadeIn 0.3s ease-in-out',
    },
    iconContainer: {
      marginBottom: '12px',
    },
    icon: {
      fontSize: '50px',
      color: '#e53935', // red tone to show "access denied" / user issue
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '10px',
      color: '#333',
    },
    message: {
      fontSize: '16px',
      fontWeight: '400',
      marginBottom: '20px',
      color: '#555',
    },
    button: {
      padding: '10px 24px',
      backgroundColor: '#007b8f',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '15px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
    },
  };





  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.iconContainer}>
              <HiOutlineUserRemove style={styles.icon} />
            </div>
            <div style={styles.title}>User Already Exists</div>
            <div style={styles.message}>
              This email is already registered.
            </div>
          </div>
        </div>
      )}
      {showCancelModal && (
      <div style={styles.overlay}>
        <div style={styles.modal}>
          <h2 style={styles.title}>Unsaved Changes</h2>
          <p style={styles.message}>
            You have unsaved changes. Are you sure you want to cancel?
          </p>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
            <button
              style={{ ...styles.button, backgroundColor: "gray" }}
              onClick={() => setShowCancelModal(false)} // Close the modal
            >
              No
            </button>
            <button
              style={styles.button}
              onClick={handleCancel} // Proceed with cancel
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    )}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-icon">&#10003;</div>
            <h2 className="modal-title">Success</h2>
            <p className="modal-message">Profile updated successfully.</p>
            <button className="modal-button" onClick={() => setIsModalOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      <div className="account-settings">
        <div style={{ backgroundColor: 'white', padding: '5px 20px' }}>
          <h2 >Check Your Vendor</h2>
        </div>
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-box">
            <div className="modal-header-settings" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1, textAlign: 'center' }}>
                  <h4 style={{ color: '#777777',fontSize:'18px', margin: 0 }}>Edit {getFieldLabel(currentField)}</h4>
                </div>
                <a className="cancel-link" onClick={() => setShowModal(false)} style={{ whiteSpace: 'nowrap' }}>
                  Cancel
                </a>
              </div>

              <div className="modal-body">
                {currentField === "name" ? (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                      <div
                        style={{
                          border: '2px dashed #ccc',
                          padding: '2rem',
                          textAlign: 'center',
                          borderRadius: '8px',
                          
                        }}
                      >
                        <p><strong>Upload Profile Picture</strong></p>

                        <input
                          id="profile-image-upload"
                          type="file"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={(e) => setProfileImage(e.target.files[0])}
                        />

                        <label htmlFor="profile-image-upload" style={{ display: 'inline-block', padding: '0.5rem 1rem', backgroundColor: '#3B82F6', color: 'white', borderRadius: '5px', cursor: 'pointer' }}>
                          Choose an Image File
                        </label>

                        <p style={{ color: '#999', fontSize: '0.9rem', marginTop: '1rem' }}>
                          Optimal icons are at least 32 pixels tall and 32 pixels wide.
                        </p>
                      </div>


                      <div style={{ display: 'flex', gap: '1rem' }}>
                        <div style={{ flex: 1 }}>
                          <label>First Name</label>
                          <input
                            type="text"
                            value={nameInputs.firstName}
                            onChange={(e) => setNameInputs({ ...nameInputs, firstName: e.target.value })}
                            style={{ width: '90%' }}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <label>Last Name</label>
                          <input
                            type="text"
                            value={nameInputs.lastName}
                            onChange={(e) => setNameInputs({ ...nameInputs, lastName: e.target.value })}
                            style={{ width: '90%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ):
                currentField === "phone" ? (
                  <>
                    <label>Phone Number</label>
                    <input
                      type="text"
                      value={newValue}
                      onChange={(e) => setNewValue(e.target.value)}
                      style={{ padding: "10px 10px" }}
                    />
                    {phoneError && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "5px",
                        }}
                      >
                        {phoneError}
                      </p>
                    )}
                  </>
                ) 
                  : currentField === "password" ? (
                    <>
                     <div className="input-wrapper" style={{ position: 'relative', marginBottom: '20px' }}>
  <label className="label">New Password</label>
  <input
    type={showNewPassword ? 'text' : 'password'}
    placeholder="Enter new password"
    className="input"
    value={passwordInputs.newPassword}
    onChange={(e) =>
      setPasswordInputs({ ...passwordInputs, newPassword: e.target.value })
    }
    style={{
      width: '95%',
      borderRadius: '5px',
      fontSize: '14px',
      position: 'relative',
    }}
  />
  <span
    className="toggle-password-icon"
    onClick={() => setShowNewPassword((prev) => !prev)}
    style={{
      position: 'absolute',
      right: '10px',
      top: '72%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      color: '#007b8f',
    }}
  >
    {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
  </span>
</div>

<div className="input-wrapper" style={{ position: 'relative', marginBottom: '20px' }}>
  <label className="label">Confirm Password</label>
  <input
    type={showConfirmPassword ? 'text' : 'password'}
    placeholder="Confirm password"
    className="input"
    value={passwordInputs.confirmPassword}
    onChange={(e) =>
      setPasswordInputs({ ...passwordInputs, confirmPassword: e.target.value })
    }
    style={{
      width: '95%',
      borderRadius: '5px',
      fontSize: '14px',
      position: 'relative',
    }}
  />
  <span
    className="toggle-password-icon"
    onClick={() => setShowConfirmPassword((prev) => !prev)}
    style={{
      position: 'absolute',
      right: '10px',
      top: '72%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      color: '#007b8f',
    }}
  >
    {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
  </span>
</div>
                    </>
                  ) : currentField === "email" ? (
                    <>
                      {emailStep === 1 ? (
                        <>
                          <label>New Email Address</label>
                          <input
                            type="email"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            style={{padding:'10px 10px'}}
                          />
                          <button onClick={handleSendOtp} className="modal-button" style={{padding:'10px 10px'}}>
                            Send Verification Code
                          </button>
                        </>
                      ) : (
                        <>
                          <label>Enter Confirmation Code</label>
                          <input
                            type="text"
                            value={otpCode}
                            onChange={(e) => setOtpCode(e.target.value)}
                            style={{padding:'10px 10px'}}
                          />
                          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.5rem" }}>

                            <button onClick={handleChangeEmail} className="modal-button" style={{padding:'10px 10px'}}>
                              Change Email Address
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )


                    : (
                      <>
                        <label >New {getFieldLabel(currentField)}</label>
                        <input
                          type="text"
                          value={newValue}
                          onChange={(e) => setNewValue(e.target.value)}
                          style={{padding:'10px 10px'}}
                        />
                      </>
                    )}
                {currentField === "password" ? (
                  <button onClick={handlepassSubmit} className="modal-button" style={{padding:'10px 10px'}}>Change Password</button>
                ) :
                  currentField === "email" ? (
                    <></>
                  ) : (
                    <button onClick={handleSubmit} className="modal-button" style={{padding:'10px 10px'}}>Submit</button>
                  )}

              </div>
            </div>
          </div>
        )}

        <div className="settings-container">
          <h2>Account Settings</h2>

          <div className="section">
            <div className="field-group">
              <div className="field-label">
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <label className="label-text">Email Address</label>
                  <span className="verified-container"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.63472 0.702427C8.51979 0.518791 8.35046 0.375556 8.15032 0.29266C7.95017 0.209764 7.72916 0.19133 7.51805 0.239927L6.01971 0.584093C5.86616 0.619386 5.7066 0.619386 5.55305 0.584093L4.05471 0.239927C3.8436 0.19133 3.62259 0.209764 3.42244 0.29266C3.2223 0.375556 3.05297 0.518791 2.93805 0.702427L2.12138 2.00576C2.03805 2.13909 1.92555 2.25159 1.79221 2.33576L0.488881 3.15243C0.305562 3.26725 0.162537 3.4363 0.0796585 3.6361C-0.00322004 3.83591 -0.021841 4.05656 0.0263803 4.26743L0.370547 5.76743C0.405712 5.92071 0.405712 6.07997 0.370547 6.23326L0.0263803 7.73243C-0.0220284 7.94342 -0.00350116 8.16425 0.0793863 8.36422C0.162274 8.5642 0.305404 8.73338 0.488881 8.84826L1.79221 9.66493C1.92555 9.74826 2.03805 9.86076 2.12221 9.99409L2.93888 11.2974C3.17388 11.6733 3.62221 11.8591 4.05471 11.7599L5.55305 11.4158C5.7066 11.3805 5.86616 11.3805 6.01971 11.4158L7.51888 11.7599C7.72987 11.8083 7.9507 11.7898 8.15068 11.7069C8.35065 11.624 8.51984 11.4809 8.63472 11.2974L9.45138 9.99409C9.53471 9.86076 9.64721 9.74826 9.78055 9.66493L11.0847 8.84826C11.2682 8.73322 11.4113 8.56384 11.494 8.36371C11.5768 8.16357 11.5951 7.94262 11.5464 7.73159L11.203 6.23326C11.1678 6.07971 11.1678 5.92015 11.203 5.76659L11.5472 4.26743C11.5957 4.05652 11.5773 3.83575 11.4946 3.63579C11.4118 3.43582 11.2689 3.26659 11.0855 3.15159L9.78138 2.33493C9.64823 2.25144 9.5357 2.13891 9.45221 2.00576L8.63472 0.702427ZM8.21555 4.14159C8.26709 4.04682 8.27986 3.93574 8.25117 3.83174C8.22248 3.72773 8.15457 3.63891 8.06173 3.58396C7.96889 3.52901 7.85835 3.51222 7.75337 3.53711C7.6484 3.562 7.55717 3.62664 7.49888 3.71743L5.31971 7.40576L4.00388 6.14576C3.96484 6.10568 3.91814 6.07387 3.86654 6.05223C3.81494 6.03059 3.75952 6.01956 3.70357 6.01981C3.64762 6.02005 3.59229 6.03156 3.54089 6.05365C3.48948 6.07574 3.44305 6.10795 3.40437 6.14837C3.36568 6.18879 3.33553 6.23659 3.31572 6.28892C3.29591 6.34124 3.28683 6.39702 3.28904 6.45293C3.29125 6.50883 3.3047 6.56372 3.32858 6.61432C3.35246 6.66492 3.38629 6.71019 3.42805 6.74743L5.12305 8.37159C5.16841 8.41497 5.22299 8.44754 5.28271 8.46686C5.34243 8.48619 5.40574 8.49178 5.46792 8.4832C5.5301 8.47463 5.58953 8.45212 5.64179 8.41735C5.69405 8.38259 5.73778 8.33646 5.76971 8.28243L8.21555 4.14159Z" fill="#4CAF50" /></svg> Verified</span>
                </div>
                <a className="edit-link" onClick={() => handleEdit("email")}>Edit</a>
              </div>
              <div className="email-box">{editData.email}</div>
            </div>

            <div class="custom-line"></div>

            <div className="field-group">
              <div className="field-label">
                <label>Password</label>
                <a className="edit-link" href="#" onClick={() => handleEdit("password")}>Change Password</a>
              </div>
              <div className="email-box">********</div>
            </div>
          </div>

          <h2>Personal Details</h2>

          <div className="section">
            <div className="field-group" style={{ display: 'flex', alignItems: 'center', }}>
              <div className="avatar" >
                {profileImage ? (
                  <img
                    src={typeof profileImage === "string" ? profileImage : URL.createObjectURL(profileImage)}
                    alt="Profile"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                  />
                ) : (
                  getInitials(editData.firstName, editData.lastName)
                )}

              </div>
              <div>
                <div className="field-label" style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '530px' }}>
                  <label className="label-text">Name</label>
                  <a className="edit-link" onClick={() => handleEdit("name")}>Edit</a>
                </div>
                <div className="email-box">{`${editData.firstName} ${editData.lastName}`}</div>
              </div>
            </div>

            <div class="custom-line"></div>

            <div className="field-group">
              <div className="field-label">
                <label className="label-text">Phone No.</label>
                <a className="edit-link" onClick={() => handleEdit("phone")}>Edit</a>
              </div>
              <div className="email-box">{editData.phone}</div>
            </div>

            <div class="custom-line"></div>

            <div className="field-group">
              <div className="field-label">
                <label className="label-text">Company</label>
                <a className="edit-link" onClick={() => handleEdit("company")}>Edit</a>
              </div>
              <div className="email-box">{editData.company}</div>
            </div>

            <div class="custom-line"></div>

            <div className="field-group">
              <div className="field-label">
                <label className="label-text">Department</label>
                <select
                  value={editData.department}
                  onChange={(e) => {
                    setEditData({ ...editData, department: e.target.value });
                    setIsDirty(true); // Mark the form as dirty when the department is changed
                  }}
                >
                  <option value="finance">Finance</option>
                  <option value="sales">Sales</option>
                  <option value="marketing">Marketing</option>
                  <option value="product">Product</option>
                  <option value="operations">Operations</option>
                  <option value="others">Others</option>
                </select>
              </div>
            </div>

            <div className="field-group">
              <div className="field-label">
                <label className="label-text">Role</label>
                <select
                  value={editData.role}
                  onChange={(e) => {setEditData({ ...editData, role: e.target.value });setIsDirty(true)}}
                >
                  <option value="manager">Manager</option>
                  <option value="executive">Executive</option>
                  <option value="intern">Intern</option>
                  <option value="others">Others</option>
                </select>
              </div>
            </div>
          </div>

          <div className="button-group">
          <button
  className="cancel"
  onClick={() => setShowCancelModal(true)} // Open the cancel confirmation modal

>
  Cancel
</button>
            <button
              className="update"
              onClick={handleSaveClick}
              disabled={!isDataChanged()}
              style={{
                backgroundColor: !isDataChanged() ? "#d3d3d3" : "#007b8f", // Grey when disabled, blue when enabled
                color: "#ffffff", // White text
                cursor: !isDataChanged() ? "not-allowed" : "pointer", // Not-allowed cursor when disabled
                opacity: !isDataChanged() ? 0.6 : 1, // Slightly transparent when disabled
                padding: "10px 24px",
                border: "none",
                borderRadius: "8px",
                fontSize: "15px",
                fontWeight: "500",
                transition: "background-color 0.2s ease-in-out",
              }}
            >
              Update Profile
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSettingsPage;
